const initialState = {
  numfacbcfrs: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "NUMFAC_BCFRS":
      return {
        ...state,
        numfacbcfrs: action.payload,
      };
    default:
      return state;
  }
}
